declare const postal: any;

export class WebshopUtils {
  public static publishCartRetrival(installationId, serviceId, plc) {
    setTimeout(
      () =>
        postal.publish({
          channel: 'MyproximusToWebshop',
          topic: 'webshop.cart.retrieval',
          data: {
            installationPointId: installationId,
            serviceId,
            plc,
          },
        }),
      1000,
    );
  }

  public static subscribeToCartEvent(callback, addSubscriptionFn) {
    setTimeout(
      () =>
        addSubscriptionFn(
          postal.subscribe({
            channel: 'webshopToMyproximus',
            topic: 'webshop.cart',
            callback: (data) => {
              callback(data);
            },
          }),
        ),
      1000,
    );
  }

  public static addProduct(
    isReverse: boolean,
    mpcuuid: string,
    type: string,
    chargeEvent: string,
    chargeCode: string,
    action: 'remove' | 'add',
    treatmentCode?: any,
    promoCode?: string,
    isPremium?: boolean,
  ) {
    postal.publish({
      channel: 'MyproximusToWebshop',
      topic: 'webshop.cart.items',
      data: {
        action,
        isReverse,
        product: {
          mpcUuid: mpcuuid,
          type,
          chargeEvent,
          chargeCode,
          parameters: {
            treatmentCode: treatmentCode
              ? treatmentCode.treatmentCodeAccepted
              : undefined,
            rejectedTreatmentCodes: treatmentCode
              ? treatmentCode.treatmentCodeRejected
              : undefined,
            isPremium: isPremium
          },
          promoCode
        },
      },
    });
  }

  public static removeProduct(
    isReverse,
    mpcuuid,
    type,
    chargeEvent,
    chargeCode,
  ) {
    postal.publish({
      channel: 'MyproximusToWebshop',
      topic: 'webshop.cart.items',
      data: {
        action: 'remove',
        isReverse,
        product: {
          mpcUuid: mpcuuid,
          type,
          chargeEvent,
          chargeCode,
        },
      },
    });
  }

  public static subscribeToConfirmationEvent(callback, addSubscriptionFn) {
    setTimeout(
      () =>
        addSubscriptionFn(
          postal.subscribe({
            channel: 'webshopToMyproximus',
            topic: 'webshop.confirmation',
            callback,
          }),
        ),
      1000,
    );
  }

  public static subscribeToErrorEvent(callback, addSubscriptionFn) {
    setTimeout(
      () =>
        addSubscriptionFn(
          postal.subscribe({
            channel: 'webshopToMyproximus',
            topic: 'webshop.error',
            callback,
          }),
        ),
      1000,
    );
  }

  public static subscribeToCloseEvent(callback, addSubscriptionFn) {
    setTimeout(
      () =>
        addSubscriptionFn(
          postal.subscribe({
            channel: 'webshopToMyproximus',
            topic: 'webshop.close',
            callback,
          }),
        ),
      1000,
    );
  }

  public static configureMpayThreshold(
    threshold,
    mpcuuid,
    type,
    chargeEvent,
    chargeCode,
  ) {
    postal.publish({
      channel: 'MyproximusToWebshop',
      topic: 'webshop.cart.items',
      data: {
        action: 'configure',
        configurationDetails: {
          mcommerceThreshold: threshold,
        },
        product: {
          mpcUuid: mpcuuid,
          type,
          chargeEvent,
          chargeCode,
        },
      },
    });
  }

  public static configureTryAndBuy(
    endOfTrialDecision: string,
    mpcUuid: string,
    type: string,
    treatmentCode?,
  ) {
    postal.publish({
      channel: 'MyproximusToWebshop',
      topic: 'webshop.cart.items',
      data: {
        action: 'configure',
        configurationDetails: {
          endOfTrialDecision,
        },
        product: {
          mpcUuid,
          type,
          chargeEvent: null,
          chargeCode: null,
        },
        parameters: {
          treatmentCode: treatmentCode
            ? treatmentCode.treatmentCodeAccepted
            : undefined,
          rejectedTreatmentCodes: treatmentCode
            ? treatmentCode.treatmentCodeRejected
            : undefined,
        },
      },
    });
  }

  public static manageNspProducts(orderInfo: any) {
    postal.publish({
      channel: 'MyproximusToWebshop',
      topic: 'webshop.cart.items',
      data: {
        orderInfo,
      },
    });
  }
}

export enum CartStatus {
  pendingOrder = 'PENDING_ORDER',
  loaded = 'LOADED',
  pending = 'PENDING',
}

export function getOfferListFromStorage(treatmentCode: string) {
  if (treatmentCode) {
    const item = JSON.parse(window.localStorage.getItem(treatmentCode));
    if (item && item.offerList) {
      const rejectedOffers = item.offerList
        .filter((offer) => offer.status === 'rejected')
        .map((offer) => offer.code);
      return {
        treatmentCodeAccepted: treatmentCode,
        treatmentCodeRejected: rejectedOffers,
        backUrl: item.backUrl,
      };
    } else {
      return undefined;
    }
  }
  return undefined;
}
